import React, { Component } from "react";
import { s360ConfigService } from "../../Services/S360Config";
import HWLog from "../../HWLibrary/HWLog";
import dayjs from "dayjs";
import Select from "react-select";
import { isNullOrUndefined } from "../../HWLibrary/HWUtils";
class MessageA13 extends Component {

    constructor(){

        super();
        this.state = {value: '',actionDone:false};
    }


    render() {
        let optionsArray = this.parseListValues().map(item => { return { value: item.value, label: item.name } });
        return (
            <div aria-disabled={!this.state.value} className="s360-message-cotainer-custom-a13-received">
                <div className="s360-message-box-custom-a13-received" style={this.messageBoxStyle()}>
                    <Select options={optionsArray} captureMenuScroll={false} isSearchable={false}  onChange={this.onListItemSelect} styles={this.selectOptionsStyle} components={{ IndicatorSeparator: () => null }}/>
                </div>
                {this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(this.props.sentTimestamp).format("h:mm a")}</div>}
                <div className="s360-message-cotainer-received">
                    <button disabled={!this.state.value} className="s360-message-box-custom-a15-received" onClick={this.onSubmit} onMouseEnter={this.onMouseEnterButton} onMouseLeave={this.onMouseLeaveButton} style={this.messageBoxSubmitStyle()}>
                        Submit
                    </button>
                </div>
            </div>
        );
    }

    onMouseEnterButton = (e) => {
        if (!e.target) { return }
        if (e.target.disabled === true) { return }
        const designDetails = s360ConfigService.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonHighlightTextColor)       ? "#f8f5f5" : designDetails.buttonHighlightTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonHighlightBackgroundColor) ? "#2935dd" : designDetails.buttonHighlightBackgroundColor;
    }

    onMouseLeaveButton = (e) => {
        if (!e.target) { return }
        // if (e.target.disabled === true) { return }
        const designDetails = s360ConfigService.config.designDetails;
        e.target.style.color           = isNullOrUndefined(designDetails.buttonTextColor)       ? "#0092ed" : designDetails.buttonTextColor;
        e.target.style.backgroundColor = isNullOrUndefined(designDetails.buttonBackgroundColor) ? "#fff" : designDetails.buttonBackgroundColor;
    }
    
    onListItemSelect = (item) => {

        if(this.state.actionDone){
            this.setState({value: false});
        }
        else{
        this.setState({value: item.value});
        }
       //this.props.actions.sendMessage(item.value);
    }

    onSubmit = (e) => {
        this.onMouseLeaveButton(e);
        this.setState({value: false,actionDone:true});
       this.props.actions.sendMessage(this.state.value);
    }

    parseListValues = () => {
        try {
            return JSON.parse(this.props.entry.text).data || []
        } catch (error) {
            HWLog.warn("Invalid List Data for Custom Type A13:");
        }
        return []
    }

    messageBoxStyle = () => {
        return { background: s360ConfigService.config.designDetails.senderMessageColor, fontFamily: s360ConfigService.config.designDetails.SenderMessageFont, fontSize: s360ConfigService.config.designDetails.SenderMessageFontSize, color: s360ConfigService.config.designDetails.senderMessageFontColor }
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
    }

    messageTimeStyle = () => {
        return { fontFamily: s360ConfigService.config.designDetails.messageFont, fontSize: s360ConfigService.config.designDetails.messageTimeFontSize, color: s360ConfigService.config.designDetails.messageTimeFontColor }
    }
    
    messageBoxSubmitStyle = () => {
        const designDetials = s360ConfigService.config.designDetails;
        let styleData = { 
            // background: s360ConfigService.config.designDetails.recieverMessageColor, 
            fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont, 
            fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize, 
            // color: s360ConfigService.config.designDetails.recieverMessageFontColor,
            marginLeft: '15px',
            borderWidth:"1px", 
            borderStyle: "solid",
            borderColor: isNullOrUndefined(designDetials.buttonBorderColor) ? "#0092ed" : designDetials.buttonBorderColor,

            borderRadius:    isNullOrUndefined(designDetials.buttonBorderRadius)    ? 20 : designDetials.buttonBorderRadius,
            color:           isNullOrUndefined(designDetials.buttonTextColor)       ? "#0092ed" : designDetials.buttonTextColor,
            backgroundColor: isNullOrUndefined(designDetials.buttonBackgroundColor) ? "#fff" : designDetials.buttonBackgroundColor,
        }
        return styleData;
        // return { 
        //     background: s360ConfigService.config.designDetails.recieverMessageColor,
        //      fontFamily: s360ConfigService.config.designDetails.ReceiverMessageFont, 
        //      fontSize: s360ConfigService.config.designDetails.ReceiverMessageFontSize, 
        //      color: s360ConfigService.config.designDetails.recieverMessageFontColor,
        //      marginLeft: '15px' 
        //     }
    }

    selectOptionsStyle = {
        control: (provided, state) => ({
            ...provided,
            border: "none",
            boxShadow: 'none',
            borderRadius: '0px',
            color: s360ConfigService.config.designDetails.headerColor,
            width: '100% !important',
            '&:hover': {
                border: "none"
            }
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: s360ConfigService.config.designDetails.headerColor,
        }),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = s360ConfigService.config.designDetails.headerColor;
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                        ? color
                            : null,
                ':active': {
                    ...styles[':active'],
                    backgroundColor: null,
                },
                borderBottom: '1px solid #ccc',
            };
        },
    };


}

export default MessageA13;